import React from "react";
import { Typography } from '@material-ui/core';
import './NoData.css';

const NoData = () => {
  return (
    <div class="main">
      <Typography component="div">{"No Data Found. Please Change the Location and try again"}</Typography>
    </div>
  );
};

export default NoData;
